import { useTranslation } from 'react-i18next'
import { getPrescriptionType, PrescriptionTransform } from '@ca/common'
import CollapsibleSectionRow from '@ui/elements/SectionRow/CollapsibleSectionRow'
import Row from '@ui/elements/SectionRow/NestedRow'
import PrescriptionTypeBadge from '@order/PrescriptionTypeBadge'

import { SectionProps } from '../types'
import { format } from 'date-fns'
import { getErpDate } from '@ca/common/types'
import { useDateAgo } from '@ui/elements/DateAgo'
import { Values } from '@screens/vision/values/Content'

type Props = SectionProps

export default function RefractionSection({ data }: Props) {
  const { t } = useTranslation(['ui', 'common', 'order'])
  const header = 'order:details.sections.refraction.header'
  const label = 'order:details.labels'

  const dateAgo = useDateAgo()

  const refraction = data.config.refraction
  const prescription = PrescriptionTransform.fromErpOrderRefraction(refraction)
  const createdAt = getErpDate(prescription.create_date)

  const { optometrist, optometrist_name } = prescription

  const author = {
    id: optometrist ? `${optometrist}` : undefined,
    name: optometrist_name ? `${optometrist_name}` : t('common:optician'),
  }

  return (
    <CollapsibleSectionRow
      icon="eye-table"
      title={t(`${header}.title`)}
      desc={t(`${header}.desc`)}
    >
      <Row
        icon="info-circle"
        title={t(`${label}.type`)}
        body={
          <PrescriptionTypeBadge
            type={getPrescriptionType(prescription.name)}
          />
        }
      />
      <Row
        icon="calendar-plus"
        title={t(`${label}.createdAt`)}
        texts={[format(createdAt, 'dd.MM.yyyy HH:mm:ss'), dateAgo(createdAt)]}
      />
      <Row
        icon="shield"
        title={t(`${label}.author`)}
        texts={[author.name, author.id]}
      />
      <Values showHeader={false} collapsible={false} data={prescription} />
    </CollapsibleSectionRow>
  )
}
